const buildCableUrl = (anonymousToken) => {
  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
  const base = `${protocol}//${window.location.host}/cable`
  if (!anonymousToken) return base
  const params = new URLSearchParams({ anonymous_token: anonymousToken })
  return `${base}?${params.toString()}`
}

const buildIdentifier = (sessionId) => JSON.stringify({
  channel: 'ContextSessionChannel',
  context_session_id: Number(sessionId),
})

export const contextSessionRealtimeService = {
  subscribe(sessionId, handlers = {}, options = {}) {
    const socket = new WebSocket(buildCableUrl(options.anonymousToken))
    const identifier = buildIdentifier(sessionId)
    let disposed = false

    socket.onopen = () => {
      if (disposed) {
        socket.close()
        return
      }
      socket.send(JSON.stringify({
        command: 'subscribe',
        identifier,
      }))
      if (handlers.onConnected) handlers.onConnected()
    }

    socket.onmessage = (event) => {
      try {
        const payload = JSON.parse(event.data)
        if (payload.type === 'welcome' || payload.type === 'ping' || payload.type === 'confirm_subscription') {
          return
        }

        if (payload.type === 'reject_subscription') {
          handlers.onError?.(new Error('Realtime subscription rejected'))
          return
        }

        if (payload.message) {
          handlers.onEvent?.(payload.message)
        }
      } catch (error) {
        handlers.onError?.(error)
      }
    }

    socket.onerror = (event) => {
      handlers.onError?.(event)
    }

    socket.onclose = () => {
      handlers.onDisconnected?.()
    }

    return () => {
      disposed = true
      if (socket.readyState === WebSocket.OPEN) {
        socket.send(JSON.stringify({
          command: 'unsubscribe',
          identifier,
        }))
      }
      socket.close()
    }
  },
}
